// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { orderDetailsButtonSetStyles } from "@guestsupply/Overrides/Widgets/OrderDetails/OrderDetailsButtonSet";
import { css } from "styled-components";

orderDetailsButtonSetStyles.rmaButton = {
    variant: "secondary",
    css: css`
        white-space: nowrap;
    `,
};

orderDetailsButtonSetStyles.spinner = {
    size: 22,
    css: css`
        margin: 8px 45px 0 33px;
    `,
};

orderDetailsButtonSetStyles.buttonsWrapper = {
    css: css`
        display: flex;
        justify-content: flex-end;
        clear: both;
        padding-top: 3px;
    `,
};
orderDetailsButtonSetStyles.buttonWrapper = {
    css: css`
        margin-left: 10px;
    `,
};

orderDetailsButtonSetStyles.reorderNotificationContainer = {
    css: css`
        display: flex;
        align-items: center;
        gap: 5px;
    `
}